export default {
  en: {
    login: {
      title: 'Login to Ooca Admin',
      username: 'Username',
      password: 'Password',
      loginBtn: 'Login',
    },
  },
  th: {
    login: {},
  },
};
